import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const JourneyBarGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space[1]};
  width: 100%;
`;
